import axios from "axios";

const defaultBaseUrl =
  process.env.REACT_APP_API_BASE_URL ||
  (typeof window !== "undefined" ? window.location.origin : "");

const API = axios.create({
  baseURL: defaultBaseUrl
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      window.dispatchEvent(new Event("auth:expired"));
    }
    return Promise.reject(error);
  }
);

export default API;
